import { breakpoints } from '@gassan-ui'
import { motion } from 'framer-motion'
import styled from 'styled-components'

export { default as Accordion } from './Accordion'
export { default as Footer } from './Footer'
export { default as Header } from './Header'

export const Background = styled(motion.div)`
  background: #fff;
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: ${(p) => p.theme.zIndices.mobileFilters.overlay};
`

Background.defaultProps = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
}

export const Content = styled.div`
  overflow-y: auto;
  scroll-behavior: smooth;
  width: 100%;
  height: 100%;
  padding-top: 5rem;
  padding-bottom: calc(env(safe-area-inset-bottom) + 5rem);
  @media screen and (min-width: ${breakpoints.small}) {
    padding-top: 5.5rem;
    padding-bottom: 7.5rem;
  }
`
